import { IUser } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class UserService extends BaseService<IUser> {
  constructor() {
    super('users');
  }
  canDelete = true;

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };

  getAll = async () => {
    const res = await axiosPrivate.get<IUser[]>(`${this.modulePrefix}/`);
    return res.data;
  };

  // Custom methods
  registerUser = async (entity: IUser) => {
    const res = await axiosPrivate.post(`register_user`, entity);
    return res.data;
  };

  update = async (id: number | string, entity: Partial<IUser>) => {
    if (entity.groups) {
      const transformedEntity = {
        ...entity,
        groups: Array.isArray(entity.groups) ? entity.groups : [entity.groups]
      };
      return super.update(id, transformedEntity);
    }
    return super.update(id, entity);
  };

  selectWarehouse = async (warehouse: string | null) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/select-warehouse/`, {
      warehouse: warehouse ?? ''
    });
    return res.data;
  };
}

export const userService = new UserService();
